<div class="one-dialog">
    <mat-dialog-content>
        <div class="content d-flex">
            <div class="icon">
                <mat-icon class="ic" color="warn">warning</mat-icon>
            </div>
            <div class="message" [innerHtml]="message"></div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <button mat-button mat-dialog-close>Hủy bỏ</button>
        <button mat-raised-button color="warn" (click)="onOk()">OK</button>
    </mat-dialog-actions>
</div>